import {GenericService, ResultType} from '@/shared/xhttp';
import {LongueursVente} from '@/models';

export class LongueursVenteService extends GenericService<LongueursVente> {
	
	public getAll(): Promise<ResultType<LongueursVente>> {
		return this.getC('', 200, 0, 'name');
	}
	
}